import { Injectable, NgZone } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiProvider } from '../providers/api.provider';
import { Stops, Parcel, Stop } from '../models/live-route';
import { LiveRouteStatus } from '../models/live-route-status';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/database';
import { Address } from '../models/address';
import { OptimizationStatus } from '../models/dto-optimizationstatus';
import { OptimizationService } from './optimization.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class RouteOptimizationService {

  private currentStopsSubject: BehaviorSubject<OptimizationStatus>;
  public currentStops: Observable<OptimizationStatus>;
  public RouteID:number = 0;
  public RouteDate:Date = new Date();
  public CurrentDataRoot: OptimizationStatus = new OptimizationStatus();
  constructor(
    public apiProvider: ApiProvider,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private db: AngularFireDatabase,
    private zone: NgZone,
    ) {
      this.currentStopsSubject = new BehaviorSubject<OptimizationStatus>(null);
      //this.currentStopsSubject.getValue().StopsList[0].ParcelCompress[0].No_Stop
    }

  public get currentStopsValue(): OptimizationStatus {
    return this.currentStopsSubject.value;
  }


    /*
  public get visibleStops(): Stop[] {
    return this.currentStopsValue.StopsList.filter(x => (this.authenticationService.currentUserValue.FilterCompleted == 0 ||
      (this.authenticationService.currentUserValue.FilterCompleted == 1 && x.TotalScanned == x.ParcelCompress.length) ||
      (this.authenticationService.currentUserValue.FilterCompleted == 2 && x.TotalScanned != x.ParcelCompress.length) ));
  }
    */









  async initialiseOptimization(){
    //this.removeStorage();

    const that = this;

    if(this.RouteID > 0 && this.RouteDate != null){

      // await this.apiProvider.getStopsParcels(this.RouteID, this.minLiveRouteStatus, LiveRouteStatus.Successful, this.datePipe.transform(this.RouteDate, 'yyyy-MM-dd')).subscribe(
      //     (stops: Stops) => {

      //       this.currentStopsSubject = new BehaviorSubject<Stops>(stops);
      //       this.currentStops = this.currentStopsSubject.asObservable();
      //       this.dataSource = new MatTableDataSource<Stop>(stops.StopsList);
      //       this.StopCount = stops.StopsList.length;
      //       this.latitude = stops.StopsList[0].Address.Latitude;
      //       this.longitude = stops.StopsList[0].Address.Longitude;
      //     },
      //     (err: HttpErrorResponse) => {
      //       this.currentStopsSubject.next(null);
      //     });


      const RouteListener = this.db.database.ref('OptimizationStatus');
     // this.CurrentDataRoot = new OptimizationStatus();
     //  that.CurrentDataRoot.ModeDescription =  '---';

          RouteListener.once('value', snapshot => {
          snapshot.forEach(childSnapshot => {
               // console.log(childSnapshot);
                const FirebaseRouteId = childSnapshot.key;
                const OptimizationModeListener = this.db.database.ref('OptimizationStatus/' + FirebaseRouteId + "/Mode");
                if (Number(FirebaseRouteId) !== this.RouteID) {
                    OptimizationModeListener.off();
                    // console.log('stop listening :' + FirebaseRouteId);
                }
                else {

                
                    const refStopChanged = this.db.database.ref('OptimizationStatus/' + this.RouteID);

                    refStopChanged.on('child_added', oneroutedata => {


                        if (!that.CurrentDataRoot) {
                            that.CurrentDataRoot = new OptimizationStatus();
                          }
                          else {

                            if (oneroutedata.key === 'Mode') {
                                  const optimizationmode = String(oneroutedata.val());
                                  switch(optimizationmode) {
                                    case "1": {
                                      that.CurrentDataRoot.ModeDescription = that.CurrentDataRoot.Mode = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeAuto');
                                       break;
                                    }
                                    case "2": {
                                      that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                                       break;
                                    }
                                    case "3": {
                                      that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeReoptimization');
                                       break;
                                    }
                                    case "4": {
                                      that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                                       break;
                                    }
                                    default: {
                                      that.CurrentDataRoot.ModeDescription =  '---';
                                       break;
                                    }
                                 }

                                  // if ( oneroutedata.val() === 1) {
                                  //   that.CurrentDataRoot.ModeDescription = that.CurrentDataRoot.Mode = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeAuto');
                                  // }
                                  // if ( oneroutedata.val() === 2) {
                                  //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');

                                  // }
                                  // if ( oneroutedata.val() === 3) {
                                  //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeReoptimization');
                                  // }
                                  // if ( oneroutedata.val() === 4) {
                                  //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                                  // }

                                  that.CurrentDataRoot.Mode =  oneroutedata.val();

                            }
                          }
                          this.zone.run(() => {
                               //that.currentStopsSubject = new BehaviorSubject<Stops>(that.CurrentDataRoot);
                               that.currentStops = that.currentStopsSubject.asObservable();
                               // that.StopCount = childSnapshot.val().StopsList.length;
                          });
                        }
                    );

                    refStopChanged.on('child_changed', oneroutedata => {


                        if (!that.CurrentDataRoot) {
                            that.CurrentDataRoot = new OptimizationStatus();
                          }
                          else {

                            if (oneroutedata.key === 'Mode') {

                              const optimizationmode = String(oneroutedata.val());
                              switch(optimizationmode) {
                                case "1": {
                                  that.CurrentDataRoot.ModeDescription = that.CurrentDataRoot.Mode = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeAuto');
                                   break;
                                }
                                case "2": {
                                  that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                                   break;
                                }
                                case "3": {
                                  that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeReoptimization');
                                   break;
                                }
                                case "4": {
                                  that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                                   break;
                                }
                                default: {
                                  that.CurrentDataRoot.ModeDescription = '---';
                                   break;
                                }
                             }

                              // if ( Number(oneroutedata.val()) === 1) {
                              //   that.CurrentDataRoot.ModeDescription = that.CurrentDataRoot.Mode = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeAuto');
                              // }
                              // if ( Number(oneroutedata.val()) === 2) {
                              //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                              // }
                              // if ( Number(oneroutedata.val()) === 3) {
                              //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeReoptimization');
                              // }
                              // if ( Number(oneroutedata.val()) === 4) {
                              //   that.CurrentDataRoot.ModeDescription = that.translate.instant('overlay-stop-list-component-optimizationstatus.ModeETA');
                              // }
                              that.CurrentDataRoot.Mode =  oneroutedata.val();
                            }


                            //this.currentStopsValue.StopsList = data;
                            //this.currentStopsValue = currentStopsSubject;
                          }

                          this.zone.run(() => {
                               //that.currentStopsSubject = new BehaviorSubject<Stops>(that.CurrentDataRoot);
                               that.currentStops = that.currentStopsSubject.asObservable();

                               // that.StopCount = childSnapshot.val().StopsList.length;
                          });
                        }
                    );

                }
        });
      });
    }

  }



private snapshotToArray(snapshot) {
  const returnArr = [];

  for (let key in snapshot) {
    let value = snapshot[key];
    returnArr.push(value);
  }


  return returnArr;
}



  private RecreateMarker(Stopinfo: Stop): Stop {

    const newaddress: Address = new Address();
    const newmarker: Stop = new Stop();
    const parcelcom: Parcel[] = [];


    newaddress.Address1 = String(Stopinfo.Address.Address1);
    newaddress.Address2 = String(Stopinfo.Address.Address2);
    newaddress.City = String(Stopinfo.Address.City);
    newaddress.Latitude = Number(Stopinfo.Address.Latitude);
    newaddress.Longitude =  Number(Stopinfo.Address.Longitude);
    newaddress.Postal_Code = String(Stopinfo.Address.Postal_Code);
    newaddress.Phone =  String(Stopinfo.Address.Phone);

    newmarker.Lr_Account_ID = String(Stopinfo.Lr_Account_ID);
    newmarker.CustomerName = String(Stopinfo.CustomerName);
    newmarker.Lr_Phone = String(Stopinfo.Lr_Phone);
    newmarker.MaxCOD_TYPE = Number(Stopinfo.MaxCOD_TYPE);
    newmarker.No_Stop = Number(Stopinfo.No_Stop);
    newmarker.Min_Live_Route_Status = Number(Stopinfo.Min_Live_Route_Status);
    newmarker.Max_Live_Route_Status = Number(Stopinfo.MaxCOD_TYPE);
    newmarker.Forecasted_Arrival_Time = Stopinfo.Forecasted_Arrival_Time;

    newmarker.Address = newaddress;

    for (let i = 0; i <  Stopinfo.ParcelCompress.length; i++) {
      const onenewparcel: Parcel = new Parcel;
      onenewparcel.CODAmount = Number(Stopinfo.ParcelCompress[i].CODAmount);
      onenewparcel.CODType = String(Stopinfo.ParcelCompress[i].CODType);
      onenewparcel.Dangerous = Stopinfo.ParcelCompress[i].Dangerous;
      onenewparcel.Frozen_Protection = Stopinfo.ParcelCompress[i].Frozen_Protection;
      onenewparcel.Live_Route_Status = Number(Stopinfo.ParcelCompress[i].Live_Route_Status);
      onenewparcel.Live_Route_Type = Number(Stopinfo.ParcelCompress[i].Live_Route_Type);
      onenewparcel.No_Stop = Number(Stopinfo.ParcelCompress[i].No_Stop);
      onenewparcel.Parcel_ID = Number(Stopinfo.ParcelCompress[i].Parcel_ID);
      onenewparcel.Service_10H30 = Stopinfo.ParcelCompress[i].Service_10H30;
      parcelcom.push(onenewparcel);
    }

    newmarker.ParcelCompress = parcelcom;
    newmarker.Shipping_ID = Number(Stopinfo.Shipping_ID);
    newmarker.TotalCODAmount = Number(Stopinfo.TotalCODAmount);
    newmarker.TotalFrozen_Protection =  Stopinfo.TotalFrozen_Protection;
    newmarker.TotalParcel =  Number(Stopinfo.TotalParcel);
    newmarker.TotalPickup =  Number(Stopinfo.TotalPickup);
    newmarker.TotalScanned =  Number(Stopinfo.TotalScanned);
    newmarker.TotalService_10H30 =  Number(Stopinfo.TotalService_10H30);
      return newmarker;
    }


    public getPrintRoutePDF(routeId: number, date: Date): Observable<Blob> {
      return this.apiProvider.getPrintRoutePDF(routeId, date);
    }

}
